"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _TopicFooterContent = require("@insided/destination/modules/Content/TopicList/TopicFooterContent");

var _TopicViewsCount = require("@insided/destination/uikit/TopicViewsCount");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TopicRepliesCount = _interopRequireDefault(require("./TopicRepliesCount"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListItemCardFooter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItemCardFooter, _Component);

  var _super = _createSuper(TopicListItemCardFooter);

  function TopicListItemCardFooter() {
    (0, _classCallCheck2.default)(this, TopicListItemCardFooter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicListItemCardFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topic = _this$props.topic,
          lastTopicContributor = _this$props.lastTopicContributor,
          userId = _this$props.userId,
          showUnsubscribeBtn = _this$props.showUnsubscribeBtn,
          handleFavoriteRemoval = _this$props.handleFavoriteRemoval;
      var lastActivityAt = topic.lastActivityAt,
          topicUrl = topic.topicUrl,
          lastReplyPublicId = topic.lastReplyPublicId,
          lastActivityAtRelative = topic.lastActivityAtRelative,
          likedOrVotedByCurrentUser = topic.likedOrVotedByCurrentUser,
          replyCount = topic.replyCount,
          unreadRepliesCount = topic.unreadRepliesCount,
          publicId = topic.publicId,
          views = topic.views;
      var lastPostUrl = lastReplyPublicId ? "".concat(topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination, "?postid=").concat(lastReplyPublicId, "#post").concat(lastReplyPublicId) : topicUrl === null || topicUrl === void 0 ? void 0 : topicUrl.destination;
      return (0, _preact.h)("div", {
        className: "topic-list-item-card_footer-container"
      }, (0, _preact.h)("div", {
        className: "topic-list-item-card_topic-metrics"
      }, showUnsubscribeBtn && (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)("i", {
          "aria-hidden": "true",
          className: (0, _classnames.default)('icon--star-full', 'icon--auto-width', 'thread-meta-item__icon', 'thread-meta-item__text--highlight', 'qa-topic-meta-favorite-icon'),
          onClick: function onClick() {
            return handleFavoriteRemoval();
          }
        }),
        tooltipMessage: (0, _translations.t)('Forum', 'thread.unsubscribe'),
        qaClasses: "qa-title-tooltip"
      }), (0, _preact.h)(_TopicFooterContent.TopicLikeVoteButtonView, {
        topicId: topic.id,
        contentType: topic.contentType,
        votes: topic.votes,
        likes: topic.likes,
        isGuest: !userId,
        hasCurrentUserLiked: likedOrVotedByCurrentUser
      }), (0, _preact.h)(_TopicViewsCount.TopicViewsCountAction, {
        href: (0, _absoluteUrlRuntime.resolveUrl)(topicUrl.destination),
        "data-track-type": "click",
        "data-element-name": "Search result topic meta link"
      }, (0, _preact.h)(_TopicViewsCount.TopicViewsCount, {
        views: views
      })), (0, _preact.h)(_TopicRepliesCount.default, {
        replyCount: replyCount,
        unreadRepliesCount: unreadRepliesCount,
        publicId: publicId,
        lastPostUrl: lastPostUrl
      })), (0, _preact.h)("div", {
        className: "topic-list-item-card_topic-age-container"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: lastTopicContributor,
        extraClass: "avatar"
      }), (0, _preact.h)("a", {
        "data-track-type": "click",
        href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl),
        "aria-label": "Last post relative creation date"
      }, (0, _preact.h)("time", {
        dateTime: lastActivityAt ? new Date(lastActivityAt).toISOString() : undefined
      }, lastActivityAtRelative))));
    }
  }]);
  return TopicListItemCardFooter;
}(_preact.Component);

var _default = TopicListItemCardFooter;
exports.default = _default;